const voucherpopup = document.querySelector('[voucher-popup]') || null;
const close_voucher_btn = document.querySelector('[close-voucher-popup]') || null;
const claim_voucher_btn = document.querySelector('[handle-claim-voucher-button]') || null;

const voucherDetailpopup = document.querySelector('[voucher-details-popup]') || null;
const close_detail_btn = document.querySelectorAll('[close-details-popup]') || null;

document.addEventListener('DOMContentLoaded', function() {
  setupVoucherGrid();
});

close_voucher_btn.addEventListener('click', function() {
  voucherpopup.classList.remove(BUTTON_ACTIVE_CLASS);
});
claim_voucher_btn.addEventListener('click', function() {
  voucherpopup.querySelector('.claim-voucher-form').style.display = 'none';
  voucherpopup.querySelector('.claimed-voucher-success').style.display = 'block';
  claim_voucher_init();
});

close_detail_btn.forEach(button => {
  button.addEventListener('click', function() {
    voucherDetailpopup.classList.remove(BUTTON_ACTIVE_CLASS);
  });
})

const fetchVouchers = () => {
  const fetchUrl = `/apps/express-proxy/vouchers?u=${customerid}`;
  return fetch(fetchUrl)
  .then((res) => res.json())
  .then((res) => {
    const data = res;
    return data;
  })
  .catch((err) => console.error(`[Backend Vouchers] Failed to load`, err));
};

const setupVoucherGrid = async () => {
  const voucherGrid = document.querySelector(selectors.voucherGrid) || false;
  let voucherCardsHTML = '';
  if (voucherGrid) {
    const requests = await fetchVouchers();
    const responses = await Promise.all(requests);

    responses.forEach(voucher => {
      let html = '';
     
      if(!voucher.claimVouchers) {
        html =  `<div class="col-lg-4 col-md-4 col-sm-6 col-12">
            <div class="card rounded-0">
                <div class="card-body">
                    <h5 class="sub-title mb-3">${voucher.value}€ <br> ${voucher.name}</h5>
                    <div class="d-flex align-items-center justify-content-between">
                        <div class="desc d-flex align-items-center">
                            <svg class="me-2" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M12 22.75C8 22.75 4.75 19.88 4.75 16.35V12.65C4.75 12.24 5.09 11.9 5.5 11.9C5.91 11.9 6.25 12.24 6.25 12.65C6.25 15.27 8.72 17.25 12 17.25C15.28 17.25 17.75 15.27 17.75 12.65C17.75 12.24 18.09 11.9 18.5 11.9C18.91 11.9 19.25 12.24 19.25 12.65V16.35C19.25 19.88 16 22.75 12 22.75ZM6.25 16.46C6.32 19.11 8.87 21.25 12 21.25C15.13 21.25 17.68 19.11 17.75 16.46C16.45 17.87 14.39 18.75 12 18.75C9.61 18.75 7.56 17.87 6.25 16.46Z" fill="#17181A"></path>
                            <path d="M12 13.75C9.24 13.75 6.75999 12.51 5.54999 10.51C5.02999 9.66 4.75 8.67 4.75 7.65C4.75 5.93 5.52 4.31 6.91 3.09C8.27 1.9 10.08 1.25 12 1.25C13.92 1.25 15.72 1.9 17.09 3.08C18.48 4.31 19.25 5.93 19.25 7.65C19.25 8.67 18.97 9.65 18.45 10.51C17.24 12.51 14.76 13.75 12 13.75ZM12 2.75C10.44 2.75 8.98001 3.27 7.89001 4.23C6.83001 5.15 6.25 6.37 6.25 7.65C6.25 8.4 6.44999 9.1 6.82999 9.73C7.77999 11.29 9.76 12.25 12 12.25C14.24 12.25 16.22 11.28 17.17 9.73C17.56 9.1 17.75 8.4 17.75 7.65C17.75 6.37 17.17 5.15 16.1 4.21C15.01 3.27 13.56 2.75 12 2.75Z" fill="#17181A"></path>
                            <path d="M12 18.75C7.87 18.75 4.75 16.13 4.75 12.65V7.65C4.75 4.12 8 1.25 12 1.25C13.92 1.25 15.72 1.9 17.09 3.08C18.48 4.31 19.25 5.93 19.25 7.65V12.65C19.25 16.13 16.13 18.75 12 18.75ZM12 2.75C8.83 2.75 6.25 4.95 6.25 7.65V12.65C6.25 15.27 8.72 17.25 12 17.25C15.28 17.25 17.75 15.27 17.75 12.65V7.65C17.75 6.37 17.17 5.15 16.1 4.21C15.01 3.27 13.56 2.75 12 2.75Z" fill="#17181A"></path>
                            </svg>
                            ${voucher.points} points
                        </div>
                        <button data-voucher-id="${voucher._id}" type="button" class="button button-dark voucher-unlock-button rounded-0 text-uppercase d-flex align-items-center">
                        ${voucher.status}
                        </button>
                    </div>
                </div>
            </div>
        </div>`;
      } else if(voucher.claimVouchers.status == 'Approved') {
       
       html =  `<div class="col-lg-4 col-md-4 col-sm-6 col-12">
              <div class="card rounded-0">
                <div class="card-body">
                  <h5 class="sub-title mb-3">200€ <br> Free sample</h5>
                  <div class="d-flex align-items-center justify-content-between">
                    <div class="desc show-voucher-button" data-voucher-id="${voucher._id}">Detail</div>
                    <button type="button" class="button button-outline-dark rounded-0 text-uppercase d-flex align-items-center">
                      UNLOCKED
                      <svg class="ms-2" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M17.1088 4.55806C17.3528 4.80214 17.3528 5.19786 17.1088 5.44194L7.9421 14.6086C7.69803 14.8527 7.3023 14.8527 7.05822 14.6086L2.89155 10.4419C2.64748 10.1979 2.64748 9.80214 2.89155 9.55806C3.13563 9.31398 3.53136 9.31398 3.77544 9.55806L7.50016 13.2828L16.2249 4.55806C16.469 4.31398 16.8647 4.31398 17.1088 4.55806Z" fill="black"></path>
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </div>`
      } else if(voucher.claimVouchers.status == 'Requested') {
        html =  `<div class="col-lg-4 col-md-4 col-sm-6 col-12">
            <div class="card rounded-0">
                <div class="card-body">
                    <h5 class="sub-title mb-3">${voucher.value}€ <br> ${voucher.name}</h5>
                    <div class="d-flex align-items-center justify-content-between">
                        <div class="desc d-flex align-items-center">
                            <svg class="me-2" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M12 22.75C8 22.75 4.75 19.88 4.75 16.35V12.65C4.75 12.24 5.09 11.9 5.5 11.9C5.91 11.9 6.25 12.24 6.25 12.65C6.25 15.27 8.72 17.25 12 17.25C15.28 17.25 17.75 15.27 17.75 12.65C17.75 12.24 18.09 11.9 18.5 11.9C18.91 11.9 19.25 12.24 19.25 12.65V16.35C19.25 19.88 16 22.75 12 22.75ZM6.25 16.46C6.32 19.11 8.87 21.25 12 21.25C15.13 21.25 17.68 19.11 17.75 16.46C16.45 17.87 14.39 18.75 12 18.75C9.61 18.75 7.56 17.87 6.25 16.46Z" fill="#17181A"></path>
                            <path d="M12 13.75C9.24 13.75 6.75999 12.51 5.54999 10.51C5.02999 9.66 4.75 8.67 4.75 7.65C4.75 5.93 5.52 4.31 6.91 3.09C8.27 1.9 10.08 1.25 12 1.25C13.92 1.25 15.72 1.9 17.09 3.08C18.48 4.31 19.25 5.93 19.25 7.65C19.25 8.67 18.97 9.65 18.45 10.51C17.24 12.51 14.76 13.75 12 13.75ZM12 2.75C10.44 2.75 8.98001 3.27 7.89001 4.23C6.83001 5.15 6.25 6.37 6.25 7.65C6.25 8.4 6.44999 9.1 6.82999 9.73C7.77999 11.29 9.76 12.25 12 12.25C14.24 12.25 16.22 11.28 17.17 9.73C17.56 9.1 17.75 8.4 17.75 7.65C17.75 6.37 17.17 5.15 16.1 4.21C15.01 3.27 13.56 2.75 12 2.75Z" fill="#17181A"></path>
                            <path d="M12 18.75C7.87 18.75 4.75 16.13 4.75 12.65V7.65C4.75 4.12 8 1.25 12 1.25C13.92 1.25 15.72 1.9 17.09 3.08C18.48 4.31 19.25 5.93 19.25 7.65V12.65C19.25 16.13 16.13 18.75 12 18.75ZM12 2.75C8.83 2.75 6.25 4.95 6.25 7.65V12.65C6.25 15.27 8.72 17.25 12 17.25C15.28 17.25 17.75 15.27 17.75 12.65V7.65C17.75 6.37 17.17 5.15 16.1 4.21C15.01 3.27 13.56 2.75 12 2.75Z" fill="#17181A"></path>
                            </svg>
                            ${voucher.points} points
                        </div>
                        <button disabled type="button" class="button button-dark rounded-0 text-uppercase d-flex align-items-center">
                        ${voucher.claimVouchers.status}
                        </button>
                    </div>
                </div>
            </div>
        </div>`;
      }
       
      voucherCardsHTML += html;
    });
    
    voucherGrid.innerHTML = voucherCardsHTML;

     setupVoucherButtons();

    selectors.vouchers = responses;
  }
  
};

const setupVoucherButtons = () => {
  
    const claimButtons = document.querySelectorAll('.voucher-unlock-button') || [];
    const detailButtons = document.querySelectorAll('.show-voucher-button') || [];
    if (detailButtons.length) {
      detailButtons.forEach((button) => {
        button.addEventListener('click', (e) => {
          const voucherId = button.dataset.voucherId;
          const voucherCode = voucherDetailpopup.querySelector('.voucher-code');
          selectors.vouchers.forEach(x => {
            if(x._id == voucherId) {
              
              voucherDetailpopup.classList.add(BUTTON_ACTIVE_CLASS);
              voucherCode.innerHTML = `
                <p>Use this code to receive ${x.value}€ OFF:</p>
                <p>${x.claimVouchers.dicount_code}</p>
              ` 
            }
          });
        })
      });
    }
    if (claimButtons.length) {
      claimButtons.forEach((button) => {
        button.addEventListener('click', (e) => {
          //button.disabled = true;
          if(!customerid) {
            window.location.href = "/account";
            return
          }
          const voucherId = button.dataset.voucherId;
          const popup_voucher_name = voucherpopup.querySelector('[voucher-name]');
          const popup_voucher_value = voucherpopup.querySelector('[voucher-value]');
          const popup_voucher_points = voucherpopup.querySelector('[voucher-points]');
          const popup_eligible = voucherpopup.querySelector('[not-eligible]');
          const popup_points = voucherpopup.querySelector('[handle-points]');
          const popup_claim_voucher_btn = voucherpopup.querySelector('[handle-claim-voucher-button]');
          const popup_my_points = voucherpopup.querySelector('.my-points');
          
          voucherpopup.classList.add(BUTTON_ACTIVE_CLASS);
          
          selectors.vouchers.forEach(x => {
            if(x._id == voucherId) {
              claim_voucher_btn.dataset.voucherId = x._id;
              popup_voucher_value.innerHTML = x.value;
              popup_voucher_name.innerHTML = x.name;
              popup_voucher_points.innerHTML = x.points;
              if(parseInt(x.points) <= parseInt(popup_my_points.textContent)) {
                popup_eligible.textContent = 'Congratulations! You are eligible to claim this voucher';
                popup_eligible.classList.add('text-success');
                popup_eligible.classList.remove('text-danger');
                popup_claim_voucher_btn.disabled = false;
              } else {
                popup_eligible.textContent = 'You are not eligible to claim this voucher';
                popup_eligible.classList.remove('text-success');
                popup_eligible.classList.add('text-danger');
                popup_claim_voucher_btn.disabled = true;
              }
              
            }
          })
          
          //window.location.href = '#follow-us-popup';
          //updateWishlist(productHandle);
          //button.classList.toggle(BUTTON_ACTIVE_CLASS);
        });
      });
    }
    else return;
};

const claimVoucher = (data) => {
  
  // formData.append('customer_id', customerid);
  
  const options = {
    method: "POST",
     headers: {
        "Content-Type": "application/json",
    },
    body: JSON.stringify(data)
  };
  const fetchUrl = `/apps/express-proxy/voucher/claim-voucher`;
  return fetch(fetchUrl, options)
  .then((res) => res.json())
  .then((res) => {
    
    const data = res.data;
    return data;
  })
  .catch((err) => console.error(`[Shopify Claim Reward] Failed to load content for`, err));
};   

const claim_voucher_init = async () => {
  
  const obj = {
    coupon_id: claim_voucher_btn.dataset.voucherId,
    customer_id: customerid
  }
  const claimedVoucher = await claimVoucher(obj);

  voucherpopup.querySelector('.upload-image-loading').style.display = 'none';
  voucherpopup.querySelector('.upload-image-success').style.display = 'block';
  // verify_claim_popup.querySelector('.upload-image-loading').style.display = 'none';
  // claim_verify_reward_btn.style.display = 'none';
  // verify_claim_popup.querySelector('.upload-image-success').style.display = 'block';
  // verify_claim_popup.querySelector('.close-verify-popup-button').style.display = 'block';
  //const responses = await Promise.all(requests);
}